var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRatingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0489 2.92731C11.3483 2.006 12.6517 2.006 12.9511 2.92731L14.4697 7.60107C14.6035 8.0131 14.9875 8.29206 15.4207 8.29206H20.335C21.3037 8.29206 21.7065 9.53167 20.9228 10.1011L16.947 12.9896C16.5965 13.2443 16.4499 13.6956 16.5838 14.1077L18.1024 18.7814C18.4017 19.7027 17.3472 20.4688 16.5635 19.8994L12.5878 17.0109C12.2373 16.7563 11.7627 16.7563 11.4122 17.0109L7.43647 19.8994C6.65276 20.4688 5.59828 19.7027 5.89763 18.7814L7.41623 14.1077C7.5501 13.6956 7.40344 13.2443 7.05296 12.9896L3.07722 10.1011C2.2935 9.53167 2.69628 8.29206 3.665 8.29206H8.57929C9.01251 8.29206 9.39647 8.0131 9.53034 7.60107L11.0489 2.92731Z",
    fill: "#FFD058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRatingFilled);
export default __webpack_public_path__ + "static/media/star_rating_filled.c52e464c67c2c7ba4c28a07d1c9aaaaa.svg";
export { ForwardRef as ReactComponent };